import { atom } from 'recoil';

export const iframeModalAtom = atom({
  key: 'iframeModalAtom',
  default: false,
});
